import React, { useState } from 'react';
import { Modal, Box, TextField, Typography, Button, IconButton } from '@mui/material';
import { ModalFormValues } from '../../../types';
import { Close } from '@material-ui/icons';

interface MarketDetailsModalProps {
    modalOpen: boolean;
    handleClose: () => void;
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleValidateClick: () => void;
    handleSave: () => void;
    formValues: ModalFormValues;
    showValues: boolean;
    currentTabName?:string
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
};

const MarketDetailsModal: React.FC<MarketDetailsModalProps> = ({
    modalOpen,
    handleClose,
    handleInputChange,
    handleValidateClick,
    handleSave,
    formValues,
    showValues,
    currentTabName
}) => {
    const isInputEmpty = formValues.input.trim() === '';
    const [validated, setValidated] = useState(false);
    const handleValidateAndSave = () => {
        if(currentTabName==="outletCode"){
            handleSave();
        }else{
            if (validated) {
                handleSave();
            }
        }       
    };

    return (
        <Modal
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >

            <Box sx={style}>
                <IconButton sx={() => ({
                    float: "right",
                    padding: "10px"
                })} onClick={handleClose}>
                    <Close />
                </IconButton>

                <Box p={4}>
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                                height: 100
                            }
                        }}
                        multiline
                        maxRows={4}
                        placeholder="Paste Here...."
                        value={formValues.input}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                    />
                    {/* {isInputEmpty && (
                        <Typography color="error" variant="caption">
                            Please enter some text.
                        </Typography>
                    )} */}
                    {showValues && <>
                        <Box mt={3}>
                            <Typography className='coupon-box-header-wrapper' variant="subtitle1">Matched</Typography>
                            {formValues.matched.length !== 0 ? <Typography className='modal-items' variant="body1" >
                                {formValues.matched.join(', ')}
                            </Typography> : <Typography className='modal-items' variant="body1" >
                                No matched items
                            </Typography>}
                        </Box>

                        <Box mt={4}>
                            <Typography className='coupon-box-header-wrapper unmatched-header' variant="subtitle1">Unmatched</Typography>
                            {formValues.unmatched.length !== 0 ? <Typography className='modal-items' variant="body1">
                                {formValues.unmatched.join(', ')}
                            </Typography> : <Typography className='modal-items' variant="body1" >
                                No unmatched items
                            </Typography>}
                        </Box>

                    </>}
                    <Box className={`modal-bottom ${currentTabName === "outletCode" ? "model-outlet-bottom" : ""}`} mt={2}>
                        {currentTabName!=="outletCode" && <Button className="modal-bottom-btn" variant="contained" color="primary" onClick={() => {
                            handleValidateClick();
                            setValidated(true);
                        }} disabled={isInputEmpty}>
                            Validate
                        </Button>}
                        
                        <Button className="modal-bottom-btn" variant="contained" color="primary" onClick={() => {
                            handleValidateAndSave();
                            setValidated(false);
                        }} disabled={(currentTabName === 'outletCode' ? isInputEmpty : !validated || isInputEmpty)}>
                            Save
                        </Button>
                    </Box>
                </Box>

            </Box>
        </Modal>
    );
}

export default MarketDetailsModal;
